import * as types from './mutation-types'

export const notificationGetUnreadCount = ({ commit }) => {
  return Vue2.prototype.$api.active()
    .get('notifications/unread-count')
    .then((response) => {
      commit('notificationSetUnreadCount', response.data.count)
    })
}

export const notificationGetNotifications = ({ commit }, Options) => {

  let config = Object.assign({
    url: null,
    type: 'unread',
  }, Options)

  let request = config.url
    ? axios.get(config.url)
    : Vue2.prototype.$api.active().get('notifications', {
      params: {
        filters: [config.type],
      },
    })

  return request.then((response) => {
    config.type === 'unread'
      ? commit(types.NOTIFICATION_SET_UNREAD_NOTIFICATIONS, response.data)
      : commit(types.NOTIFICATION_SET_READ_NOTIFICATIONS, response.data)
  })
}

export const notificationSetNotification = ({ commit }, notification) => {
  commit(types.NOTIFICATION_SET_NOTIFICATION, notification)
}